import { Grid, Typography } from '@mui/material'
import PublicTemplate from 'components/screens/PublicTemplate'
import React, { useEffect } from 'react'
import { PrivacyPolicyActions, PrivacyPolicyStoreStates } from '.'
import { Container, List, ListItemText } from './styles'

type PrivacyPolicyScreenProps = PrivacyPolicyActions & PrivacyPolicyStoreStates

const PrivacyPolicy = (props: PrivacyPolicyScreenProps) => {
  const { application, load } = props
  const { privacyPolicy } = application

  // mounted actions
  useEffect(() => {
    load()
  }, [load])

  if (!privacyPolicy) {
    return <></>
  }

  return (
    <PublicTemplate>
      <Container container direction="column" spacing={1}>
        <Grid>
          <Typography variant="h5" align="center" sx={{ mb: 3 }}>
            プライバシーポリシー
          </Typography>
        </Grid>
        <Grid>
          <List>
            {privacyPolicy.items.map((item, index) => (
              <li key={index}>
                {item.title}
                <ListItemText variant="body2" component="p">
                  {item.content.replace('@', '【アット】')}
                </ListItemText>
              </li>
            ))}
          </List>
        </Grid>
        <Grid>
          <Typography variant="h6" component="p">
            {privacyPolicy.dateStr}
          </Typography>
        </Grid>
      </Container>
    </PublicTemplate>
  )
}

export default PrivacyPolicy
